import { render, staticRenderFns } from "./MediaPickerModal.vue?vue&type=template&id=5e84c685"
import script from "./MediaPickerModal.vue?vue&type=script&lang=js"
export * from "./MediaPickerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports